

<p-dialog [header]="'productShare.header' | transloco" [(visible)]="isProductShareDailogVisible" [modal]="true"
    [style]="{ width: '400px' }" (onHide)="closeDailog()">
    <div class="mt-2 p-2">
        <p class="mb-2">{{ 'productShare.shareIntro' | transloco }}</p>
        <div class="d-flex  align-items-center mt-3">
            <button type="button" class="btn btn-link p-1 " (click)="onOpenFacebookUrl()" [title]="'productShare.shareOnFacebook' | transloco">
                <img src="assets/images/social/facebook.png" width="35" alt="Facebook">
            </button>
            <button type="button" class="btn btn-link p-1 ms-1" (click)="onOpenWhatsappUrl()" [title]="'productShare.shareOnWhatsApp' | transloco">
                <img src="assets/images/social/whatsapp.png" width="35" alt="WhatsApp">
            </button>
            <button type="button" class="btn btn-link p-1 ms-1" (click)="onOpenEmailUrl()" [title]="'productShare.shareViaEmail' | transloco">
                <img src="assets/images/social/email.png" width="35" alt="Email">
            </button>
            <button type="button" class="btn btn-link p-1 ms-1" (click)="shareOnPinterest()" [title]="'productShare.shareOnPinterest' | transloco">
                <img src="assets/images/social/pinterest.png" width="35" alt="Pinterest">
            </button>
            <button type="button" class="btn btn-link p-1 ms-1" (click)="shareOnReddit()" [title]="'productShare.shareOnReddit' | transloco">
                <img src="assets/images/social/reddit.png" width="35" alt="Reddit">
            </button>
        </div>
    </div>

    <div class="d-flex mt-2 p-2">
        <input type="text" id="shareLinkInput" class="form-control me-0" [(ngModel)]="shareLink" readonly>
        <button class="btn btn-primary ms-0 ms-3" pButton [label]="'productShare.copy' | transloco" (click)="copyLink()"></button>
    </div>
</p-dialog>



